import { isEmpty } from "lodash"
import moment from "moment"

const amountFormatter = (value = 0, decimal = 2) => {
  return parseFloat(value).toLocaleString("en", {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  })
}

const checkParams = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] === null ||
      obj[propName] === undefined ||
      obj[propName] === ""
    ) {
      delete obj[propName]
    }
  }

  return obj
}

const checkProperties = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] !== null &&
      obj[propName] !== undefined &&
      obj[propName] !== ""
    )
      return false
  }
  return true
}

const renderIconFileTypes = (type) => {
  switch (type) {
    case "audio":
      return "icon-audio"

    case "class":
      return "icon-class"

    case "exam":
      return "icon-exam"

    case "html":
      return "icon-html"

    case "link":
      return "icon-link"

    case "pdf":
      return "icon-pdf"

    case "sc":
      return "icon-soundcloud"

    case "survey":
      return "icon-survey"

    case "video":
    case "ivideo":
      return "icon-video"

    case "yt":
      return "icon-youtube"

    default:
  }
}

const format = (seconds) => {
  const date = new Date(seconds * 1000)
  const hh = date.getUTCHours()
  const mm = date.getUTCMinutes()
  const ss = pad(date.getUTCSeconds())
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`
  }
  return `${mm}:${ss}`
}

const pad = (string) => {
  return ("0" + string).slice(-2)
}

const isObjectHasEmpty = (obj) => {
  let result = Object.values(obj).some((property) => isEmpty(property))
  return result
}

const paginate = (array, page_size, activeItem) => {
  let slicedArray = []
  let offset = page_size - (array.length - activeItem)

  if (array.length < page_size + 1) {
    slicedArray = array.slice(0, page_size)
  } else {
    if (activeItem + 4 >= array.length) {
      slicedArray = array.slice(activeItem - offset, array.length)
    } else if (activeItem < 7) {
      slicedArray = array.slice(0, page_size)
    } else {
      slicedArray = array.slice(activeItem - 6, activeItem + 4)
    }
  }
  return slicedArray
}

const formatDate = (datetime, dateFormat) => {
  if (dateFormat) {
    return moment(datetime, dateFormat).format("MMM DD, YYYY")
  } else {
    return moment(datetime).format("MMM DD, YYYY")
  }
}

const formatTime = (datetime) => {
  return moment(datetime).format("hh:mm A")
}

const formatTimestamp = (datetime) => {
  return moment(datetime).format("DD MMM YYYY, hh:mm A")
}

const formatDuration = (duration = 0) => {
  let hours = Math.floor(duration / 60)
  let minutes = duration % 60

  let result = []
  if (hours > 0) {
    result.push(`${hours} ${hours > 1 ? "hrs" : "hr"}`)
  }

  if (minutes > 0) {
    result.push(`${minutes} ${minutes > 1 ? "mins" : "min"}`)
  }

  return result.join(" ")
}

const formatErrorMessage = (error) => {
  if (Array.isArray(error)) {
    return error.join("\n* ")
  } else {
    return error
  }
}

const isJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const isIOSDevice = () => {
  return (
    !window.MSStream && new RegExp(/iPad|iPhone|iPod/).test(navigator.userAgent)
  )
}

const isSafari = () => {
  let isSafari = false
  if (
    navigator.vendor &&
    navigator.vendor.indexOf("Apple") > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf("CriOS") === -1 &&
    navigator.userAgent.indexOf("FxiOS") === -1
  ) {
    isSafari = true
  }
  return isSafari
}

const isMatchPrimaryId = (idTemplates, primaryId, currentId) => {
  if (primaryId && Array.isArray(idTemplates)) {
    return idTemplates.some(
      (id) => id.label === primaryId && Object.values(id).includes(currentId)
    )
  }
  return false
}

const parseErrorResponse = (error) => {
  const { data = {} } = error?.response || {}

  return data
}

const formatAddress = (address, prefixLength = 6, suffixLength = 4) => {
  if (!address) {
    return ""
  }
  const length = address.length
  return `${address.substr(0, prefixLength)}...${address.substr(
    length - suffixLength,
    length
  )}`
}

const isIdVerified = (userIds = [], primaryId = false) => {
  if (Array.isArray(userIds) && userIds.length > 0) {
    if (primaryId) {
      const hasPrimaryId = userIds.some(
        (id) => id.verified && id.template === primaryId
      )

      if (hasPrimaryId) {
        return true
      } else {
        return userIds.length === 2 && userIds.every((id) => id.verified)
      }
    } else {
      return userIds.every((id) => id.verified)
    }
  } else {
    return false
  }
}

export {
  amountFormatter,
  checkParams,
  checkProperties,
  renderIconFileTypes,
  format,
  pad,
  isObjectHasEmpty,
  paginate,
  formatDate,
  formatTime,
  formatTimestamp,
  formatDuration,
  formatErrorMessage,
  isJsonString,
  isIOSDevice,
  isSafari,
  isMatchPrimaryId,
  parseErrorResponse,
  formatAddress,
  isIdVerified,
}
